/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import {useEffect, useState} from 'react'
import Link from  'next/link' 
import { useRouter } from 'next/router'

import Header from '../../components/header'
import Layout from '../../components/layout'
import style from '../../components/login.module.css'
import LoginForm from '../../components/loginForm'
import TrackIcon from '../../components/trackIcon'
import utils from '../../components/utils'
import TRACKING_CATEGORY from '../../components/consts'
import LoaderOverlay from '../../components/loaderOverlay'
import { useStateValue } from '../../state';
import MobileHeader from '../../components/mobileHeader'

export default function Login() {
  const [showError, updateShowError] = useState(false);
  const [emailAddress, updateEmailAddress] = useState("");
  const [requestSent, updateRequestSent] = useState(false);
  const [requestFailed, updateRequestFailed] = useState(false);
  const [isFirstMount, updateIsFirstMount] = useState(true);
  const [isEmbedded, updateIsEmbedded] = useState(false);

  const router = useRouter();

  useEffect(() => {
    if(isFirstMount) {
     updateIsFirstMount(false);
     utils.trackPageView('login');
    }
    }, [])

    useEffect(() => {
      let isEmbedded = router.query['embedded'];
      if(isEmbedded === 'true') {
        updateIsEmbedded(true);
      }
    }, [router])

  const [
    {user, loading},
    dispatch
  ] = useStateValue();

  function handleOnClick(e){
    e.preventDefault();
    e.stopPropagation();
    if(isEmail(emailAddress)){
      utils.trackEvent(TRACKING_CATEGORY.NEW_LEAD, 'email_subscribed','email_address',emailAddress);
      updateRequestFailed(false);
      updateRequestSent(true);
    } else {
      updateRequestSent(false);
      updateRequestFailed(true);
    }

    }
    const isEmail = (email) => {
      return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
    }

    const renderError = () => {
      return (
        <div className={style.loginError}>
        <span className={style.login}>We couldn't locate your account.
        <Link href="/posts/signup/?source=login-not-found">
        <a onClick={() => isEmbedded && parent.postMessage('close', '*')} target={isEmbedded && '_blank'} rel={isEmbedded && "noopener noreferrer"} className={style.loginLinkError}>Sign up</a>
        </Link>
        </span>
        </div>
      );
    }

    const renderSignup = () => {
      return (
        <span className={style.login}>New to FileDriver?
        <Link href="/posts/signup/?source=login-new">
        <a onClick={() => isEmbedded && parent.postMessage('close', '*')} target={isEmbedded && '_blank'} rel={isEmbedded && "noopener noreferrer"} className={style.loginLink}>Sign up</a>
        </Link>
        </span>
      )
    }

    const renderEarlySignup = () => {
      return (
        <Layout>
        <Header/>
        <div className={style.container}>
        <title>Login</title>
        <h2 className={style.Title}> Login </h2>
        <div className={style.mainContent}>
          <h3>Get Early Access To Subscribers Features</h3>
          <h4>Subscribe and be notified as soon as we release our subscribers-only features </h4>
        <div style={{margin: '0 0 15px', overflow: 'auto'}}>
        <form style={{maxWidth: '400px', opacity: requestSent ? 0.4 : 1}}>
          <div className={style.emailWrapper}>
          <input className={style.email} onChange={e => updateEmailAddress(e.target.value)} type="text" maxLength="256" placeholder="Enter Your Email"/>
          <input className={style.button}  onClick={handleOnClick} type="submit" value="GET ACCESS" disabled={requestSent}/>
          </div>
            </form>
            <div style={{display: requestSent ? 'flex' : 'none'}} className={style.successMessage}><h3>Thank you! Your submission has been received!</h3></div>
            <div style={{display: requestFailed ? 'flex' : 'none'}}  className={style.errorMessage}><div>Oops! Something went wrong while submitting the form.</div></div>
        </div>
        </div>
          </div>
      </Layout>
      )
    }

    function renderLogin() {
      return (
        <React.Fragment>
        {loading && <LoaderOverlay LoaderOverlayStyle={{zIndex: '2000'}}>
        <span className={style.loaderText}>{'Loading your profile'}</span>
        <span className={style.loaderTextSubHeadline}>It might take a few moments, please don't close this page.</span>
        </LoaderOverlay>}
        <Layout>
        <Header/>
        </Layout>
        <div className={style.signUpContainer}>
        <div style={{display: 'block', marginTop: '5vh'}}>
        <h1 className={style.signupTitle}>Log in</h1>
        <span className={style.signupDescription}>Please enter your email and we <br/> will send you a code to log in:</span>
        <LoginForm actionType='login' buttonText={'Login with email'} onError={() => updateShowError(true)}
        onSuccess={() => updateShowError(false)}
        />
        {!showError ? renderSignup() : renderError()}
        </div>
        </div>
        </React.Fragment>
      );
    }

    function renderEmbeddedLogin() {
     //parent.postMessage("embedded-login", "*");
      return (
       /*  <React.Fragment>
        <Layout extendedStyle={{height: '16%', borderBottom: '1px solid #434571', display: 'flex', justifyContent: 'center'}}>
        <MobileHeader embedded={true}/>
        </Layout>
        <div className={style.embeddedLoginContainer}>
          <span className={style.embeddedLoginTitle}>
          File Sharing You Can Trust.
          </span>
          <span className={style.embeddedLoginSubTitle}>
          Secured, reliable and beautiful. <b>It just works.</b>
          </span>
          <a target='_blank' rel="noreferrer" style={{textDecoration: 'none'}} href={'/posts/login'} id={'loginButton'} className={style.embeddedLoginButton}>
            Login
          </a>
        </div>
        </React.Fragment>*/

       <React.Fragment>
        {loading && <LoaderOverlay LoaderOverlayStyle={{zIndex: '2000'}}>
        <span className={style.loaderText}>{'Loading your profile'}</span>
        <span className={style.loaderTextSubHeadline}>It might take a few moments, please don't close this page.</span>
        </LoaderOverlay>}
        <Layout extendedStyle={{height: '16%', borderBottom: '1px solid #434571', display: 'flex', justifyContent: 'center'}}>
        <MobileHeader embedded={true} showCloseIcon={true} openInNewTab={true}/>
        </Layout>
        <div className={style.signUpContainer}>
        <div style={{display: 'block'}}>
        <h1 style={{fontSize: '22px', lineHeight: 'unset'}} className={style.signupTitle}>Log in</h1>
        <LoginForm formStyle={{width: '90%'}} actionType='login' buttonText={'Login with email'}
        onError={() => updateShowError(true)}
        onSuccess={() => updateShowError(false)}
        onCompletion={() => !isEmbedded ? router.push('/') : router.push('/?embedded=true')}
        />
        {!showError ? renderSignup() : renderError()}
        </div>
        </div>
        </React.Fragment>
      );
    }

    return (
     isEmbedded ? renderEmbeddedLogin() : user.deviceType === 'mobile' ? renderEarlySignup() : 
      renderLogin()
    );
  }